import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import FilterPill from './FilterPill'

export default withTranslation()(function PayoutFilterBar({
  t, year, onChangeYear, account, onChangeAccount, type, onChangeType, status, onChangeStatus, onExport
}) {
  const yearOptions = [2026, 2025, 2024].map((value) => ({ label: `${value}`, value }))
  const accountOptions = [
    { label: t('payout.filters.all_accounts'), value: '' },
    { label: t('payout.prize_security.title'), value: 'prize_security' }
  ]
  const typeOptions = [
    { label: t('payout.filters.all_types'), value: '' },
    ...Object.entries(t('payout.top_prize_type.types', { returnObjects: true })).map(([value, label]) => ({ label, value }))
  ]
  const statusOptions = [
    { label: t('payout.filters.all_statuses'), value: '' },
    { label: t('payout.winners_by_status.paid'), value: 'paid' },
    { label: t('payout.winners_by_status.verified'), value: 'verified' },
    { label: t('payout.winners_by_status.pending'), value: 'pending' }
  ]

  return (
    <div className="flex flex-wrap items-center gap-3 mb-5">
      <FilterPill
        label={t('payout.filters.this_year')}
        active={year ? { label: `${year}` } : null}
        options={yearOptions}
        onSelect={(option) => onChangeYear(option.value)}
      />

      <FilterPill
        label={t('payout.filters.all_accounts')}
        active={account ? { label: accountOptions.find((option) => option.value === account)?.label } : null}
        options={accountOptions}
        onSelect={(option) => onChangeAccount(option.value)}
      />

      <FilterPill
        label={t('payout.filters.all_types')}
        active={type ? { label: typeOptions.find((option) => option.value === type)?.label } : null}
        options={typeOptions}
        onSelect={(option) => onChangeType(option.value)}
      />

      <FilterPill
        label={t('payout.filters.all_statuses')}
        active={status ? { label: statusOptions.find((option) => option.value === status)?.label } : null}
        options={statusOptions}
        onSelect={(option) => onChangeStatus(option.value)}
      />

      <button
        type="button"
        onClick={onExport}
        className="ml-auto flex items-center gap-1.5 border border-border-lines rounded-full h-10 px-4 text-sm font-medium text-dark-blue whitespace-nowrap"
      >
        <UIcons.UilExport size={16} /> {t('payout.filters.export')}
      </button>
    </div>
  )
})
